import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransformDateNthPipe } from './pipe.dateNth';

/**
 * The TransformDateNth module
 *
 * import { TransformDateNthModule } from 'styleguide/src/shared/pipe/dateNth/pipe.dateNth.module';
 */
@NgModule({
    declarations: [
        TransformDateNthPipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TransformDateNthPipe
    ]
})

export class TransformDateNthModule {}
